// File: src/pages/BuilderPage.jsx
import React, { useState, useRef, useEffect } from "react";
import { ReactFlowProvider } from "reactflow";
import ShowQnsModal from "./ShowQnsModal";
import FloatingPopup from "./FloatingChatBox";
import BotFlowGraph from "./BotFlowGraph";
import QuestionForm from "./QuestionForm";
import { useSearchParams } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";
import { getbotflow, saveBotFlow } from "../../shared/ApiEndpoint";
import { CurrentUserId } from "../../shared/shared";
import builderChat from '../../../css/chatBuilder.module.css'
import { notification } from "antd";
import { isEqual } from "lodash";




export default function BuilderPage() {
   const [searchParams] = useSearchParams();
  const botId = searchParams.get("botid");
  const [open, setOpen] = useState(false);
  const [questions, setQuestions] = useState({});
  const [start_id,setStart_id]=useState(null)
  const [editQuestion, setEditQuestion] = useState(null);
  const [showQnsModal,setShowQnsModal] = useState(false);
  const [initialQuestions, setInitialQuestions] = useState({});
    const [initialstart_id,setinitialStart_id]=useState(null)
  const [hasChanges, setHasChanges] = useState(false);
  const chatRef = useRef();


  useEffect(() => {
    fetch_flowDetails(botId)
  },[botId])
useEffect(() => {
  const startChanged = start_id !== initialstart_id; // you'll need an initialStartId from props or backend
  const questionsChanged = !isEqual(initialQuestions, questions);
  setHasChanges(startChanged || questionsChanged);
}, [questions, start_id, initialQuestions, initialstart_id]);

  const handleStartChat = () => {
    chatRef.current?.startChat(); 
  };

  const fetch_flowDetails= async (bot_id) => {
    try {
      const res = await axiosInstance.get(`${getbotflow}`, {
         params: { bot_id },
        withCredentials: true});
      if(res.status===200){
        setQuestions(res?.data?.bot_flow);
        setInitialQuestions(res?.data?.bot_flow);
        setStart_id(res?.data?.start)
        setinitialStart_id(res?.data?.start)
      }
    }
    catch (error) {
      console.log(error)
    }
  }
  
  const handleSaveQuestion = (id, data) => {
    setQuestions(prev => ({ ...prev, [id]: data }));
    setEditQuestion(null);
  };

const handleUpdateConnections = ({ source, target, label }) => {
  setQuestions(prev => {
    const updated = JSON.parse(JSON.stringify(prev)); 

    const sourceQ = updated[source];
    if (!sourceQ) return prev;

    if (sourceQ.response_type === "text") {
      sourceQ.next = target;
      delete sourceQ.branches;
    } else if (sourceQ.response_type === "multiple_choice" || sourceQ.response_type === "dropdown") {
      if (!sourceQ.options || sourceQ.options.length === 0) sourceQ.options = ["Option 1"];
      if (!sourceQ.branches) sourceQ.branches = [];

      const alreadyLinked = sourceQ.branches.find(b => b.value === label);
      if (!alreadyLinked) {
        sourceQ.branches.push({ value: label, next: target });
      }

      delete sourceQ.next;
    }

    return updated;
  });
};


const handleDeleteConnection = ({ source, target, label }) => {
  setQuestions(prev => {
    const updated = JSON.parse(JSON.stringify(prev)); 

    const sourceQ = updated[source];
    if (!sourceQ) return prev;

    if (sourceQ.response_type === "text") {
      if (sourceQ.next === target) {
        delete sourceQ.next;
      }
    } else if (sourceQ.response_type === "multiple_choice" || sourceQ.response_type === "dropdown") {
      if (Array.isArray(sourceQ.branches)) {
        sourceQ.branches = sourceQ.branches.filter(
          (b) => !(b.value === label && b.next === target)
        );
        if (sourceQ.branches.length === 0) {
          delete sourceQ.branches;
        }
      }
    }

    return updated;
  });
};


const handleToggle = () => {
  setOpen((prev) => {
    const newState = !prev;
    if (newState) {
      handleStartChat();
    }
    return newState;
  });
};

  const handleEditClick = (questionId) => {
    setEditQuestion(questions[questionId]);
    console.log(questions[questionId]);
  };

  const handleDelete = (id) => {
    const newQuestions = { ...questions };
    delete newQuestions[id];

    for (const q of Object.values(newQuestions)) {
      if (q.next === id) q.next = "";
      if (q.branches) {
        q.branches = q.branches.filter(branch => branch.next !== id);
      }
      if (q.api_loop?.exit_to === id) {
        q.api_loop.exit_to = "";
      }
    }

    setQuestions(newQuestions);
    setEditQuestion(null);
  };

  const handleCopyId = (id) => {
    navigator.clipboard.writeText(id);
  };

  const handleExportJSON = () => {
  const blob = new Blob([JSON.stringify(questions, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "bot-flow.json";
  link.click();
  URL.revokeObjectURL(url);
};


const fileInputRef = useRef();

const handleImportClick = () => {
  fileInputRef.current.click();
};

const handleImportJSON = (event) => {
  const file = event.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const imported = JSON.parse(e.target.result);
      setQuestions(imported);
      setEditQuestion(null);
    } catch (err) {
      alert("Invalid JSON file");
    }
  };
  reader.readAsText(file);
};
const handleSave = async() => {
  const payload = {
  user_id:CurrentUserId,
  bot_id: botId,
  bot_flow: questions ,
  ...(start_id && {start:start_id})
};
 
  if (!hasChanges) {
    notification.info({
      key: 'no-changes',
      description: 'No changes to save',
      placement: 'topRight',
    });
    return;
  }
try {
  const resp = await axiosInstance.post(saveBotFlow, payload, {
      headers: {
    'Content-Type': 'application/json'
  },
    withCredentials: true
  });
if(resp.status === 200){
 notification.success({
  key: 'bot-flow-save-success', 
  description: 'Bot flow saved successfully!',
  placement: 'topRight',
});
 setInitialQuestions(questions);
        setHasChanges(false); // Reset changes flag

}

} catch (error) {
  console.error(error)
}
}


  return (
    
    <div className="container-fluid px-4 py-3">
         <div className="d-flex justify-content-between align-items-center mb-2">
      <h3 className="fw-bold fs-5">Bot Flow</h3>
      <div className="d-flex gap-2">
        <button  className={`${builderChat.savebtnclr}`} onClick={handleSave}>
         Save
        </button>
        <button  className={`${builderChat.savebtnclr}`}onClick={handleToggle}>
         Test your bot
        </button>

        {/* <button className={`${builderChat.savebtnclr}`}>
         Publish
        </button> */}
          <button onClick={() => setShowQnsModal(true)}  className={`${builderChat.savebtnclr}`}>
          All Questions
        </button>
        <button onClick={handleExportJSON} className={`${builderChat.savebtnclr}`}>
          Export JSON
        </button>
        <button onClick={handleImportClick} className={`${builderChat.savebtnclr}`}>
          Import JSON
        </button>
      </div>
    </div>
       <div className="row" >
    <div className="col-md-8 mb-3">
    <input
  type="file"
  accept=".json"
  ref={fileInputRef}
  onChange={handleImportJSON}
  className="d-none"
/>



      <ReactFlowProvider>
        <BotFlowGraph
          allQuestions={questions}
          onUpdateConnections={handleUpdateConnections}
          onDeleteConnection={handleDeleteConnection}
           onEditQuestion={(id) => {
      const q = questions[id];
      if (q) setEditQuestion(q); // this opens the edit form
    }}
        />
      </ReactFlowProvider>
    </div>
  <div className="col-md-4 mb-3 h-100 overflow-auto">
    <QuestionForm
      onSave={handleSaveQuestion}
      onCancel={() => setEditQuestion(null)}
      onDelete={handleDelete}
      allQuestions={questions}
      editQuestion={editQuestion}
      start_id={start_id}
      setStart_id={setStart_id}
    />
  </div>

  </div>



 <ShowQnsModal showQnsModal={showQnsModal} setShowQnsModal={setShowQnsModal} questions={questions} handleCopyId={handleCopyId} handleEditClick={handleEditClick}/>

        <FloatingPopup open={open} setOpen={setOpen} botId={botId} ref={chatRef} />
</div>

  );
}
